import { EventEmitter } from '@angular/core';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { CoreFrontendSharedModule } from '@core/frontend-shared';
import { Store } from '@ngxs/store';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
function MembershipRegistrationFormDataTableComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.header);
  }
}
function MembershipRegistrationFormDataTableComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function MembershipRegistrationFormDataTableComponent_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onClickEdit.emit(ctx_r0.subFormId));
    });
    i0.ɵɵelementEnd();
  }
}
function MembershipRegistrationFormDataTableComponent_Conditional_4_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(row_r3.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(row_r3.value);
  }
}
function MembershipRegistrationFormDataTableComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, MembershipRegistrationFormDataTableComponent_Conditional_4_For_1_Template, 5, 2, "div", 6, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r0.rows);
  }
}
function MembershipRegistrationFormDataTableComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-spinner");
  }
}
export let MembershipRegistrationFormDataTableComponent = /*#__PURE__*/(() => {
  class MembershipRegistrationFormDataTableComponent {
    constructor(store) {
      this.store = store;
      this.displayEdit = true;
      this.subFormId = null;
      this.onClickEdit = new EventEmitter();
    }
    static {
      this.ɵfac = function MembershipRegistrationFormDataTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MembershipRegistrationFormDataTableComponent)(i0.ɵɵdirectiveInject(i1.Store));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MembershipRegistrationFormDataTableComponent,
        selectors: [["membership-registration-form-data-table"]],
        inputs: {
          header: "header",
          displayEdit: "displayEdit",
          subFormId: "subFormId",
          rows: "rows"
        },
        outputs: {
          onClickEdit: "onClickEdit"
        },
        decls: 7,
        vars: 3,
        consts: [["loading", ""], [1, "flex-head", "ui-flex"], [1, "caption"], ["uiButton", "", "label", "bearbeiten", "icon", "pen", 1, "small", "edit-form"], [1, "data-table"], ["uiButton", "", "label", "bearbeiten", "icon", "pen", 1, "small", "edit-form", 3, "click"], [1, "row"], [1, "col-1"], [1, "col-2"]],
        template: function MembershipRegistrationFormDataTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵconditionalCreate(1, MembershipRegistrationFormDataTableComponent_Conditional_1_Template, 2, 1, "h3", 2);
            i0.ɵɵconditionalCreate(2, MembershipRegistrationFormDataTableComponent_Conditional_2_Template, 1, 0, "button", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 4);
            i0.ɵɵconditionalCreate(4, MembershipRegistrationFormDataTableComponent_Conditional_4_Template, 2, 0);
            i0.ɵɵtemplate(5, MembershipRegistrationFormDataTableComponent_ng_template_5_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.header ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.displayEdit ? 2 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.rows ? 4 : -1);
          }
        },
        dependencies: [CoreFrontendSharedModule, UiButtonComponent],
        styles: ["[_nghost-%COMP%]{position:relative;display:block}[_nghost-%COMP%]    +membership-registration-form-data-table{margin-top:30px}.flex-head[_ngcontent-%COMP%]{margin-bottom:20px}.flex-head[_ngcontent-%COMP%]   .caption[_ngcontent-%COMP%]{margin:0 0 6px}@media (min-width: 420px){.flex-head[_ngcontent-%COMP%]{display:flex;align-items:center}.flex-head[_ngcontent-%COMP%]   .caption[_ngcontent-%COMP%]{flex:1;margin:0}}.data-table[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]:nth-child(2n){background:var(--tableBodyRowBgColor)}.data-table[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]:nth-child(odd){background:var(--tableBodyRowEvenBgColor)}@media (max-width: 767px){.data-table[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{padding:5px 10px}.data-table[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{padding:0}.data-table[_ngcontent-%COMP%]   .col-1[_ngcontent-%COMP%]{font-size:var(--fontSizeSmall)}}@media (min-width: 768px){.data-table[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{display:flex}.data-table[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{padding:5px 10px}.data-table[_ngcontent-%COMP%]   .col-1[_ngcontent-%COMP%]{width:30%;min-width:220px}}"],
        changeDetection: 0
      });
    }
  }
  return MembershipRegistrationFormDataTableComponent;
})();